import React, { Component } from 'react';
import ajax from '../escolha/ajax';
import globalizacao from '../escolha/globalizacao';
import Stores from '../components/stores';



class HomeApps extends Component {

    state = {
        carregando: true,
        listApp: []
    }

    componentDidMount() {
        this.loadApps();
    }

    loadApps() {
        ajax({
            keyCache: "site-list-apps2",
            timeoutCache: 4 * 60 * (60 * 1000),
            url: "https://www.escolhatecnologia.com.br/apps-list.json",
            dataType: "json",
            method: "GET"
        }).then(function (list) {
            this.setState({
                carregando: false,
                listApp: list.sort(function (a, b) {

                    if (a.downloads > b.downloads) {
                        return -1;

                    }
                    if (a.downloads < b.downloads) {
                        return 1;
                    }


                    return 0;
                })
            });
        }.bind(this)).catch(function () {
            this.setState({
                listApp: [
                    {
                        "titulo": "Apps",
                        "descricao": "",
                        "img": "https://lh3.googleusercontent.com/MnBztTmz7Cs3IBdyZzqH2TI5Db_o0VZy1KRi2x2y5cf2naCV8ffkVar00VFy-pwOf6XO=rw",
                        "url": "https://escolhatecnologia.com.br/appstore/",
                        "lang": ""
                    }
                ]
            });
        }.bind(this));
    }



    render() {
        var that = this;

        return (
            <section className="secao nossos-apps fundo-white">
                <div className="limite conteudo">
                    <h2>{globalizacao.msg("nossosApps")}</h2>
                    <p>
                        {globalizacao.msg("nossosAppsTexto")}
                    </p>


                    <ul className="lista lista-apps">
                        {this.state.listApp.map(function (item, indice) {
                            var lang = globalizacao.getLinguaDoUsuario();
                            if (item.lang &&
                                lang !== item.lang) {
                                return null;
                            }
                            if (typeof item.titulo !== "string") {
                                item.titulo = item.titulo[lang] || item.titulo["en-US"];
                            }
                            if (typeof item.descricao !== "string") {
                                item.descricao = item.descricao[lang] || item.descricao["en-US"];
                            }

                            return (
                                <li key={indice}
                                    className=""
                                    style={{
                                        borderBottom: "1px solid  rgb(236, 232, 232)"
                                    }}>

                                    <a
                                        target="_blank"
                                        style={{
                                            display: "block",
                                            textDecoration: "none",
                                            color: "inherit"
                                        }}
                                        href={item.url}>
                                        <img
                                            className="app-icon"
                                            src={item.img.replace("http:", "https:")} />
                                        <span className="app-titulo">
                                            {item.titulo}
                                        </span>

                                    </a>

                                    <div className="app-download">
                                        <a
                                            className=""
                                            href={item.url}>
                                            <i className="material-icons">get_app</i>
                                        </a>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                    <Stores />
                </div>
                <div className="fundo-opacidade"></div>
            </section>

        );
    }
}

export default HomeApps;
